import React from "react";
import PropTypes from "prop-types";
import { TextWithDividerLine } from "@qgiv/core-donor";
import ConnectedPaymentPaypal from "./ConnectedPaymentPaypal";
import ConnectedApplePayPaymentMethod from "./ConnectedApplePayPaymentMethod";
import ConnectedUseADifferentPaymentMethodButton from "./ConnectedUseADifferentPaymentMethodButton";

const DigitalWalletPaymentOptions = ({
    controlId,
    displayApplePayPaymentMethod,
    displayOrText,
    displayPaymentPayPal,
    displayUseADifferentPaymentMethodButton,
    formik,
    paymentData,
}) => {
    const displayCallout = displayApplePayPaymentMethod || displayPaymentPayPal;

    return (
        <div className="col col--12 -padding-left--0 -text--center">
            {displayCallout && (
                <div className="-callout qg-vendor-digital-wallet-container">
                    {displayApplePayPaymentMethod && (
                        <div className="qg-vendor-apple-pay-button">
                            <ConnectedApplePayPaymentMethod
                                controlId={controlId}
                                formik={formik}
                            />
                        </div>
                    )}
                    {displayPaymentPayPal && (
                        <div className="qg-vendor-paypal-venmo-buttons">
                            <ConnectedPaymentPaypal
                                controlId={controlId}
                                formik={formik}
                                paymentData={paymentData}
                            />
                        </div>
                    )}
                </div>
            )}
            {displayOrText && (
                <div className="qg-vendor-digital-wallet-divider">
                    <TextWithDividerLine text="or" />
                </div>
            )}
            {displayUseADifferentPaymentMethodButton && (
                <div className="col col--12 -padding-left--0">
                    <ConnectedUseADifferentPaymentMethodButton
                        controlId={controlId}
                        formik={formik}
                    />
                </div>
            )}
        </div>
    );
};

DigitalWalletPaymentOptions.propTypes = {
    controlId: PropTypes.number.isRequired,
    displayApplePayPaymentMethod: PropTypes.bool.isRequired,
    displayOrText: PropTypes.bool.isRequired,
    displayPaymentPayPal: PropTypes.bool.isRequired,
    displayUseADifferentPaymentMethodButton: PropTypes.bool.isRequired,
    formik: PropTypes.shape({}).isRequired,
    paymentData: PropTypes.shape({}).isRequired,
};

export default DigitalWalletPaymentOptions;
